module.exports = __webpack_public_path__ + "static/media/photo45.cd9fb5b6.jpg";